import React, { useEffect, useState } from "react";
import Helper, { setSteps } from "../common/helper";

const StepsIndicator = ({ step, stepText, subTitleHeader, languages }) => {
  const steps = setSteps();
  const totalSteps = steps.length;
  return (
    <>
      <div className={`steps-indicator w-100 mb-10 mt-3`}>
        <div className="text-teal-500 flex-col gap-4">
          <span className="uppercase text-3xl align-middle xs:text-lg">
            {languages && languages.stepName ? languages.stepName : "step"}{" "}
            {step}
          </span>
          <span className="text-lg align-middle xs:text-sm">
            {" "}
            / {totalSteps}
          </span>
        </div>
        <p className="text-sm text-[#74758C] leading-5">{stepText}</p>
        <div className="mt-8 text-[#050033] text-2xl font-semibold">
          {subTitleHeader}
        </div>
      </div>
    </>
  );
};

export default StepsIndicator;
